export const TagReducerInitialState = {
  tagsById: {},
  loading: false,
  tag: null,
};
